export default __webpack_public_path__ + "static/media/method1.729f5459.png";